export default class ControlConnectionRetryPolicy {
    nextRetryDelayInMilliseconds(retryContext) {
        return 1000;
    }
}
